<template>
  <el-card
    shadow="always"
    :body-style="{ padding: '20px' }"
    v-loading="loading"
  >
    <div slot="header">
      <div>
        <UsersFiltersForm />
      </div>
    </div>
    <!-- card body -->
    <el-table
      :data="usersTableData"
      style="width: 100%"
      @sort-change="handleSortChange"
      :default-sort="{ prop: '_id', order: 'descending' }"
      size="mini"
      border
    >
      <el-table-column
        sortable="custom"
        prop="_id"
        label="ID"
        width="210"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row._id }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="login"
        label="Login"
        width="200"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row.login }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="email"
        label="email"
        width="210"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row.email }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="mobileNumber"
        label="Номер телефона"
        width="70"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row.mobileNumber || "..." }}
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="type"
        label="Тип пользователя"
        width="180"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ getTypeName(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="balance"
        label="Внутр. баланс"
        width="100"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          <a href="#" @click.prevent="handleShowUserBalanceHistory(scope.row)">
            {{ scope.row.balance || "0" }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        sortable="custom"
        prop="partnerPercent"
        label="Партнерка"
        width="100"
        label-class-name="wrap"
      >
        <template v-slot="scope">
          {{ scope.row.partnerPercent }}
        </template>
      </el-table-column>
      <el-table-column label="Действия" width="100">
        <template v-slot="scope">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            @click="handleEditUser(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleUsersPage"
      @size-change="handleUsersLimit"
      :current-page.sync="users.page"
      :page-size="users.limit"
      layout="sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 30, 50, 100, 200]"
      :total="users.totalDocs"
    >
    </el-pagination>

    <el-drawer
      :title="`Редактируем пользователя ${userEdit.login}`"
      :before-close="handleCloseEditPopup"
      :visible.sync="showEditUserPopup"
      direction="ltr"
      ref="edituserpopup"
    >
      <el-card shadow="always" :body-style="{ padding: '20px' }">
        <el-form :model="userEdit">
          <el-form-item label="Партнерка">
            <!-- <input
            type="number"
            :value="scope.row.partnerPercent"
            @change.prevent="setUserPPercent($event, scope.row)"
            placeholder="0.003 - 0,03 %"
            title="0.003 - 0,03 %"
            step="0.001"
            /> -->
            <el-input-number
              v-model="userEdit.partnerPercent"
              size="normal"
              :min="0"
              :max="0.1"
              :step="0.001"
              :controls="true"
              controls-position="both"
            >
            </el-input-number>
          </el-form-item>
          <el-form-item label="Тип">
            <el-select v-model="userEdit.type" filterable>
              <el-option
                v-for="item in sessionAwaredTypeOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <select :disabled="session.type > 1">
          <option
          v-for="option in typeOptions"
          v-bind:value="option.value"
              v-bind:selected="userEdit.type === option.value ? 'selected' : ''"
            >
            {{ option.text }}
          </option>
        </select> -->
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelUserEdit">Отмена</el-button>
          <el-button
            type="primary"
            @click="$refs.edituserpopup.closeDrawer()"
            :loading="loadingEditUser"
            >{{ loadingEditUser ? "Сохраняю ..." : "Сохранить" }}</el-button
          >
        </div>
      </el-card>
    </el-drawer>

    <el-drawer
      :title="`История баланса пользователя ${userBalance.login}`"
      :visible.sync="showUserBalanceHistoryPopup"
      :before-close="handleCloseUserBalanceHistoryPopup"
      direction="btt"
      ref="userbalancehistorypopup"
      :with-header="false"
      :destroy-on-close="true"
    >
      <BalanceHistory :user="userBalance" />
    </el-drawer>
  </el-card>
</template>
<script>
import { mapActions, mapState } from "vuex";

import UsersFiltersForm from "../../../../ui/UsersFiltersForm.vue";
import BalanceHistory from "../BalanceHistory/index.vue";

export default {
  name: "UsersTableComponent",
  components: {
    UsersFiltersForm,
    BalanceHistory
  },
  data: () => ({
    typeOptions: [
      // { text: "", value: null },
      { text: "Пользователь", value: 3 },
      { text: "Модератор", value: 2 },
      { text: "Админ", value: 1 },
      { text: "Суперадмин", value: -1 }
    ],
    userEdit: {},
    userBalance: {},
    loadingEditUser: false,
    showEditUserPopup: false,
    showUserBalanceHistoryPopup: false
  }),
  computed: {
    ...mapState("users", ["users", "loading"]),
    ...mapState("auth", ["session"]),
    sessionAwaredTypeOptions() {
      return this.typeOptions.filter(o => {
        return o.value >= this.session.type;
      });
    },
    usersTableData() {
      if (this.users && this.users.docs) {
        return this.users.docs.map(user => {
          return {
            ...user,
            id: user._id,
            balance:
              user.balance && user.balance.value && user.balance.value.balance
          };
        });
      }
      return [];
    }
  },
  methods: {
    ...mapActions("users", [
      "queryPaginationUsers",
      "goToPage",
      "changeSorting",
      "changeLimit",
      "editUser"
    ]),
    getTypeName(user) {
      const type = this.typeOptions.find(o => o.value === user.type);
      return type ? type["text"] : "...";
    },
    handleCloseEditPopup(done) {
      if (this.loadingEditUser) {
        return;
      }
      this.$confirm("Сохранить изменения?")
        .then(async _ => {
          this.loadingEditUser = true;
          try {
            await this.editUser({ id: this.userEdit._id, data: this.userEdit });
            await this.queryPaginationUsers();
            done();
          } catch (error) {
            this.$message.error("Что-то пошло не так!");
          } finally {
            this.loadingEditUser = false;
          }
        })
        .catch(_ => {
          this.cancelUserEdit();
        });
    },
    handleCloseUserBalanceHistoryPopup(done) {
      this.userBalance = {};
      done();
    },
    cancelUserEdit() {
      this.userEdit = {};
      this.loadingEditUser = false;
      this.showEditUserPopup = false;
    },
    async handleSortChange(sortData) {
      const sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
          ? `-${sortData.prop}`
          : "";
      await this.changeSorting({ sort });
    },
    handleUsersPage(page) {
      this.goToPage({ page });
    },
    handleUsersLimit(limit) {
      this.changeLimit({ limit });
    },
    setUserRole(event, user) {
      if (this.session.type > 1) return;
      const type = +event.target.value;
      //
      this.editUser({ id: user._id, data: { type } });
    },
    setUserPPercent(event, user) {
      const partnerPercent = parseFloat(event.target.value);
      //
      if (partnerPercent < 0) {
        alert("Error set user partner percent");
      }
      //
      this.editUser({ id: user._id, data: { partnerPercent } });
    },
    handleEditUser(user) {
      this.userEdit = { ...user };
      this.showEditUserPopup = true;
    },
    handleShowUserBalanceHistory(user) {
      this.userBalance = { ...user };
      this.showUserBalanceHistoryPopup = true;
    }
  },
  async mounted() {
    await this.queryPaginationUsers();
  }
};
</script>
<style>
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Users/components/UsersTable/index.vue